import { getSessionItem, setSessionItem } from './sessionStorage';

const KEY_LAST_ACTIVITY = 'lastActivity';
export const lastActivityGet = () => {
  const lastActivity = getSessionItem(KEY_LAST_ACTIVITY);
  return lastActivity ? Number(lastActivity) : -1;
};
export const lastActivitySet = () => setSessionItem(KEY_LAST_ACTIVITY, Date.now());
export const isActiveSince = (period) => Date.now() - lastActivityGet() < period;
